import React from 'react'

function Header() {
    return (
        <div className="flex justify-between w-full max-w-[400px] items-center px-4 pt-3 pb-2">
          <img src="/assets/img/Footer logo.png" alt="digitmoney logo" className="h-[17px] w-[100px]" />
          <img src="/assets/img/a5896383819167dd74ef6cf5641208811b1d6333.png" alt="fatakpay logo" className="h-[15px] w-[88px]" />
        </div>
    )
}

export default Header